import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Mail, ArrowLeft, CheckCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('E-posta adresinizi girin');
      return;
    }

    setLoading(true);

    try {
      await axios.post('/auth/forgot-password', { email });
      setSubmitted(true);
      toast.success('Şifre sıfırlama bağlantısı gönderildi');
    } catch (error) {
      // Güvenlik: Her durumda aynı mesajı göster
      setSubmitted(true);
      toast.success('Şifre sıfırlama bağlantısı gönderildi');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-brand-dark flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <Card className="border-border/40 shadow-xl">
            <CardContent className="pt-8 pb-8 text-center">
              <div className="mx-auto bg-primary/20 text-primary p-4 rounded-full w-fit mb-6">
                <CheckCircle className="h-8 w-8" />
              </div>
              <h2 className="text-xl font-bold text-white mb-3">E-posta Gönderildi</h2>
              <p className="text-slate-400 mb-6">
                <strong>{email}</strong> adresine şifre sıfırlama bağlantısı gönderdik. 
                Lütfen gelen kutunuzu ve spam klasörünüzü kontrol edin.
              </p>
              <p className="text-sm text-slate-500 mb-6">
                Bağlantı 1 saat içinde geçerliliğini yitirecektir.
              </p>
              <div className="space-y-3">
                <Link to="/login">
                  <Button variant="outline" className="w-full">
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Giriş Sayfasına Dön
                  </Button>
                </Link>
                <button 
                  onClick={() => setSubmitted(false)}
                  className="text-sm text-primary hover:underline"
                >
                  Farklı bir e-posta dene
                </button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Card className="border-border/40 shadow-xl">
          <CardHeader className="text-center">
            <div className="mx-auto bg-primary text-primary-foreground p-3 rounded-full w-fit mb-4 glow-green">
              <Mail className="h-6 w-6" />
            </div>
            <CardTitle className="text-2xl font-heading">Şifremi Unuttum</CardTitle>
            <CardDescription>
              E-posta adresinizi girin, şifre sıfırlama bağlantısı gönderelim.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">E-posta Adresi</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="ornek@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-field"
                  required
                />
              </div>
              <Button
                type="submit"
                className="w-full btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Gönderiliyor...
                  </>
                ) : (
                  'Sıfırlama Bağlantısı Gönder'
                )}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <Link to="/login" className="text-sm text-slate-400 hover:text-white flex items-center justify-center gap-2">
                <ArrowLeft className="h-4 w-4" />
                Giriş sayfasına dön
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
